var React = require('react');

function Danger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"#262626","key":0}),React.createElement("path",{"d":"M14.8286 9.17163L9.17176 14.8285","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M9.17139 9.17163L14.8282 14.8285","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Danger.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Danger;

Danger.default = Danger;
